"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LargeTitle: function() {
        return _index.LargeTitle;
    },
    largeTitleClassNames: function() {
        return _index.largeTitleClassNames;
    }
});
const _index = require("./components/presets/LargeTitle/index");
